var _path, _g, _path2, _path3, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgWbtcErc20(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 36,
    height: 36,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#a)"
  }, /*#__PURE__*/React.createElement("mask", {
    id: "b",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 0,
    y: 0,
    width: 36,
    height: 36
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M18 0C8.06 0 0 8.059 0 18c0 9.94 8.06 18 18 18 9.941 0 18-8.06 18-18 0-9.941-8.06-18-18-18z",
    fill: "#4EAF94"
  }))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#c)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m29.354 7.555-.989.989a13.993 13.993 0 0 1 0 18.886l.989.989a15.407 15.407 0 0 0 0-20.887v.023zM8.564 7.64a13.993 13.993 0 0 1 18.887 0l.988-.988a15.407 15.407 0 0 0-20.886 0l1.011.988zM7.64 27.441a13.994 13.994 0 0 1 0-18.876l-.988-.989a15.407 15.407 0 0 0 0 20.886l.988-1.02zM27.44 28.354a13.993 13.993 0 0 1-18.887 0l-.989.988a15.407 15.407 0 0 0 20.887 0l-1.012-.988z",
    fill: "#5A5564"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M24.238 14.703c-.198-2.063-1.977-2.755-4.227-2.965v-2.84h-1.74v2.787h-1.39V8.897h-1.727v2.86h-3.529v1.862s1.285-.023 1.265 0a.9.9 0 0 1 .989.764v7.83a.609.609 0 0 1-.211.424.603.603 0 0 1-.448.152c.023.02-1.266 0-1.266 0l-.329 2.079h3.496v2.906h1.74V24.91h1.39v2.85h1.743v-2.873c2.94-.178 4.989-.903 5.245-3.655.208-2.214-.833-3.202-2.497-3.6 1.011-.498 1.637-1.42 1.496-2.93zM21.8 20.891c0 2.161-3.704 1.914-4.883 1.914V18.97c1.18.003 4.883-.336 4.883 1.92zm-.808-5.404c0 1.977-3.09 1.737-4.072 1.737v-3.486c.982 0 4.072-.31 4.072 1.75z",
    fill: "#F09242"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M17.997 36a18 18 0 1 1 .006-36 18 18 0 0 1-.006 36zm0-34.596a16.587 16.587 0 1 0 .026 33.173 16.587 16.587 0 0 0-.026-33.173z",
    fill: "#282138"
  }))), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.7,
    fill: "#000",
    d: "M-4 19.5h43.909V30H-4z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M9.936 28.5H5.085V21h4.851v1.023H6.204v2.045H9.19v1.023H6.204v2.386h3.732V28.5zM15.537 28.5h-1.12v-1.364h-.373v-.681h-.373v-.682h-.373v-.682h-1.493V28.5h-1.12V21h3.732v.34h.373v.342h.374v.34h.373v2.046h-.373v.341h-.373v.341h-.374v.682h.373v.682h.374v.681h.373V28.5zm-1.12-4.773v-1.363h-.373v-.341h-2.24v2.045h2.24v-.34h.373zM21.137 27.477h-.373v.341h-.373v.341h-.373v.341h-2.24v-.34h-.373v-.342h-.373v-.34h-.373v-.342h-.373v-4.772h.373v-.341h.373v-.341h.373v-.341h.374V21h2.239v.34h.373v.342h.373v.34h.373v1.024h-1.12v-.682h-.372v-.341h-1.493v.34h-.373v.341h-.374v4.091h.374v.341h.373v.341h1.493v-.34h.373v-.683h1.12v1.023zM26.738 28.5h-4.852v-2.727h.373v-.341h.374v-.341h.373v-.341h.373v-.34h1.493v-.342h.373v-.34h.373v-1.364h-.373v-.341H23.38v.34h-.373v.683h-1.12v-1.023h.373v-.341h.374v-.341h.373V21h2.612v.34h.374v.342h.373v.34h.373v2.046h-.373v.341h-.373v.341h-.374v.34h-.373v.342h-1.493v.34h-.373v.342h-.373v1.363h3.732V28.5zM32.339 27.136h-.374v.341h-.373v.341h-.373v.341h-.373v.341H28.98v-.34h-.373v-.342h-.374v-.34h-.373v-.342h-.373v-4.772h.373v-.341h.373v-.341h.373v-.341h.374V21h1.866v.34h.373v.342h.373v.34h.373v.342h.374v4.772zm-1.493-4.431v-.682H28.98v.34h-.373v3.75h.373v-.681h.373v-.682h.373v-.682h.373v-.682h.373v-.681h.374zm.373 4.431v-3.409h-.373v.682h-.373v.682h-.374v.682h-.373v.681h-.373v.682h-.373v.341h1.866v-.34h.373z",
    fill: "#fff"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "a"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 36,
    height: 36,
    rx: 18,
    fill: "#fff"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "c"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    d: "M0 0h36v36H0z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWbtcErc20);
export default __webpack_public_path__ + "static/media/WBTC-ERC20.240abd3764098d8e164c7d8fc3fd84b7.svg";
export { ForwardRef as ReactComponent };